import $ from 'jquery'; // Needed because slinky is a jQuery plugin
import { min992, max992 } from "../utils"; // Use for handling Media Queries

const inlinevideos = () => {
    // function initInstagramVideoAutoplay(root = document) {
    //     root.querySelectorAll('.instagram-gallery-item__media').forEach(video => {
    //         if (video.dataset.autoplayInit) return;

    //         video.dataset.autoplayInit = 'true';
    //         video.muted = true;
    //         video.playsInline = true;
    //         video.autoplay = true;
    //         video.loop = true;
    //         video.removeAttribute('controls');

    //         video.addEventListener('canplay', () => {
    //             video.play().catch(() => {});
    //         }, { once: true });
    //     });
    // }

    // // Run once in case some videos already exist
    // initInstagramVideoAutoplay();

    // // Observe future DOM changes
    // const observer = new MutationObserver(mutations => {
    //     mutations.forEach(mutation => {
    //         mutation.addedNodes.forEach(node => {
    //             if (node.nodeType !== 1) return;

    //             if (node.matches?.('.instagram-gallery-item__media')) {
    //                 initInstagramVideoAutoplay(node.parentNode);
    //             } else if (node.querySelectorAll) {
    //                 initInstagramVideoAutoplay(node);
    //             }
    //         });
    //     });
    // });

    // observer.observe(document.body, {
    //     childList: true,
    //     subtree: true
    // });


    const videos = document.querySelectorAll('.wp-block-straightdeal-splitsection video');

    videos.forEach(video => {
        video.setAttribute('autoplay', '');
        video.setAttribute('loop', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');

        // Required for Safari
        video.muted = true;
        video.playsInline = true;

        // Attempt autoplay safely
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(() => {
                // Autoplay blocked – silently fail
            });
        }
    });

}

export default inlinevideos